import { INotification } from "shared/components/organisms/AppNotification/@types";
import { IMetadataPostMetadata } from "shared/components/organisms/AppNotification/@types/postTypes";
import { Notification } from "shared/components/organisms/AppNotification/components/molecules/Notification";
import { formatTimeAgo } from "shared/components/organisms/AppNotification/utils/formatTimeAgo";
import { makeNotificationTextsDTO } from "shared/components/organisms/AppNotification/utils/makeNotificationTextsDTO";

interface IDefaultNotificationProps {
  notification: INotification<IMetadataPostMetadata>;
}

export const DefaultNotification = ({
  notification,
}: IDefaultNotificationProps) => {
  const notificationTextsDTO = makeNotificationTextsDTO(notification);

  return (
    <Notification.Container wasReaded={!!notification?.read_at}>
      <Notification.IllustrationContainer>
        <Notification.UserPhoto
          photoSrc={notification?.metadata?.commenter?.photo}
          username={notification?.metadata?.commenter?.display_name}
        />
      </Notification.IllustrationContainer>

      <Notification.Title.Container>
        <Notification.Title.Highlight>
          {notification?.metadata?.commenter?.display_name}
        </Notification.Title.Highlight>

        <Notification.Title.Text>
          {notificationTextsDTO?.currentUserPost}
        </Notification.Title.Text>
      </Notification.Title.Container>

      <Notification.Content.Container>
        <Notification.Content.Text>
          {notificationTextsDTO?.commenterAnswer}
        </Notification.Content.Text>
      </Notification.Content.Container>

      <Notification.Footer.Container>
        <Notification.Footer.Text>
          {formatTimeAgo(notification?.created_at)}
        </Notification.Footer.Text>

        <Notification.Footer.Dot />

        <Notification.Footer.Image
          label={notificationTextsDTO?.contentLocation}
          src={notificationTextsDTO?.contentPhotoSrc}
          backgroundColor={notificationTextsDTO?.contentPhotoFallback}
        />
      </Notification.Footer.Container>
    </Notification.Container>
  );
};
